<ng-content [select]="tabTitle"></ng-content>
<div [hidden]="!active" class="pane" [attr.data-au]="'tab-content'">
  <ng-content [select]="tabContent"></ng-content>
</div>